import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'
import { Box, Typography } from '@material-ui/core'
import { getColorByGradYear, getGradYearToClassNameMap } from './util'

const useStyles = makeStyles((theme) => ({
  circle: {
    height: 18,
    width: 18,
    borderRadius: 9,
  },
  label: {
    fontSize: 14,
    marginLeft: theme.spacing(1),
  },
  tooltip: {
    margin: theme.spacing(2),
    display: 'flex',
    flexDirection: 'row',
  },
}))

const TooltipContent = ({ seniorGradYear, gradYear, value }) => {
  const classes = useStyles()

  return (
    <Box className={classes.tooltip}>
      <Box
        className={classes.circle}
        style={{ backgroundColor: getColorByGradYear(seniorGradYear, gradYear) }}
      />
      <Typography
        variant="body1"
        className={classes.label}
      >
        {getGradYearToClassNameMap(seniorGradYear)[gradYear]} ({value.toLocaleString()})
      </Typography>
    </Box>
  )
}

TooltipContent.propTypes = {
  seniorGradYear: PropTypes.number.isRequired,
  gradYear: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
}

export default TooltipContent
